export const act = {
  id: undefined,
  number: '',
  send_date: '',
  sign_date: '',
  act_status_id: '',
  is_original_exists: false,
  contract_id: '',
  costs: 0,
  act_roadmaps: [],
  object_resources: []
}
